import { isTouch } from "../core-modules/utils";
import styled from "styled-components";

const TabButton = styled.button`
  align-items: center;
  background-color: #ececec;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  color: #000000;
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  font-family: ${(props) => props.theme.fonts.bold};
  height: 65px;
  justify-content: center;
  letter-spacing: 2px;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  text-decoration: none;
  text-transform: uppercase;

  &::after {
    align-items: center;
    background-color: #000000;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #ffffff;
    content: "${(props) => {
      return props.children;
    }}";
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: opacity 200ms;
    width: 100%;
    z-index: 0;
    padding-left: 20px;
    padding-right: 20px;
  }

  ${(props) => {
    if (props.active) {
      return `
        &::after {
          opacity: 1;
        }
      `;
    }
  }}

  ${() => {
    if (!isTouch()) {
      return `
        &:hover {
          &::after {
            opacity: 1;
          }
        }
      `;
    }
  }}
`;

export default TabButton;
